import { GraphQLEnumType } from 'graphql';

export const AMAudienceDiversity = {
  ALL_STUDENTS: 'ALL_STUDENTS',
  FEMALE_STUDENTS: 'FEMALE_STUDENTS',
  MALE_STUDENTS: 'MALE_STUDENTS',
  RACIAL_AND_ETHNIC_MINORITY: 'RACIAL_AND_ETHNIC_MINORITY',
  SCHOOLS_WITH_HIGH_FRL_RATE: 'SCHOOLS_WITH_HIGH_FRL_RATE',
};

const AMAudienceDiversityType = new GraphQLEnumType({
  name: 'AMAudienceDiversity',
  description: 'An enumeration of diversity types for ActiveMatch Audiences',
  values: {
    ALL_STUDENTS: { value: AMAudienceDiversity.ALL_STUDENTS, description: 'All students' },
    FEMALE_STUDENTS: { value: AMAudienceDiversity.FEMALE_STUDENTS, description: 'Female students ' },
    MALE_STUDENTS: { value: AMAudienceDiversity.MALE_STUDENTS, description: 'Male students' },
    RACIAL_AND_ETHNIC_MINORITY: { value: AMAudienceDiversity.RACIAL_AND_ETHNIC_MINORITY, description: 'Racial and ethnic minorities' },
    SCHOOLS_WITH_HIGH_FRL_RATE: {
      value: AMAudienceDiversity.SCHOOLS_WITH_HIGH_FRL_RATE,
      description: 'High schools with high free and reduced lunch rate',
    },
  },
});
export default AMAudienceDiversityType;
